import React, { useRef } from 'react';
import { Box, Dialog, DialogContent, Paper } from '@mui/material';
import Draggable from 'react-draggable';
import Spinner from 'react-spinner-material';
import { DialogTitle } from './DialogTitle';
import { DialogActions } from './DialogActions';

function PaperComponent(props) {
  const ref = useRef({});

  const draggableModal = document.getElementsByClassName('react-draggable')[0];
  const handleOnDrag = (event, data) => {
    if (!draggableModal) return;
    const documentElement = document.documentElement;
    const wrapperHeight = window.innerHeight || documentElement.clientHeight;
    const wrapperWidth = window.innerWidth || documentElement.clientWidth;
    const elemRect = draggableModal.getBoundingClientRect();
    if (
      data.x < (elemRect.width - wrapperWidth) / 2 ||
      data.x > (wrapperWidth - elemRect.width) / 2 ||
      data.y < (elemRect.height - wrapperHeight) / 2 ||
      data.y > (wrapperHeight - elemRect.height) / 2
    )
      return false;
  };

  return (
    <Draggable
      nodeRef={ref}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      onDrag={(e, d) => handleOnDrag(e, d)}
    >
      <Paper ref={ref} {...props} />
    </Draggable>
  );
}

export default function DraggableModal({
  title,
  handleClose,
  children,
  isLoading = false,
  noMinHeight = false,
  maxWidth = 'sm',
  fullWidth = false,
  actions,
  contentOptions = {},
  ...passThrough
}) {
  return (
    <Dialog
      open={true}
      onClose={(event, reason) => reason === 'backdropClick' || handleClose()}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={{
        '& .react-draggable': {
          minWidth: maxWidth && fullWidth ? undefined : '554px',
          maxWidth: maxWidth && fullWidth ? undefined : 'none !important',
        },
      }}
      {...passThrough}
    >
      <Box
        sx={{ backgroundColor: 'primary.main', height: 8, mx: -5, mb: 1.5 }}
      />
      <DialogTitle
        title={title}
        sx={{ cursor: 'move' }}
        id="draggable-dialog-title"
        onClose={handleClose}
      />
      <DialogContent
        {...contentOptions}
        style={{ position: 'relative', minHeight: !noMinHeight ? 500 : 'none' }}
      >
        {children}
        <Box
          sx={{
            position: 'absolute',
            top: 'calc(50% - 60px)',
            left: 'calc(50% - 60px)',
          }}
        >
          <Spinner
            size={120}
            spinnerWidth={10}
            spinnerColor="#333"
            visible={isLoading}
          />
        </Box>
      </DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
}
